import { Component, OnInit, Inject, HostListener } from "@angular/core";
import { DOCUMENT } from "@angular/common";

/** @dynamic */
@Component({
  selector: "app-scroll-to-top",
  template:
    '<div class="scroll-to-top" [ngClass]="{\'show-scrollTop\': windowScrolled}">\
    <div class="text-center"><i class="fas fa-arrow-circle-up icon" (click)="scrollToTop()"></i></div>\
  </div>',
  styleUrls: ["./scroll-to-top.component.less"],
})
export class ScrollToTopComponent implements OnInit {
  windowScrolled: boolean;
  constructor(@Inject(DOCUMENT) private document: Document) {}
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (window.pageYOffset > 100 || document.documentElement.scrollTop > 100 || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    } else if ((this.windowScrolled && window.pageYOffset < 10) || document.documentElement.scrollTop < 10 || document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }
  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    })();
  }
  ngOnInit() {}
}
